import { Box, Link, Text, useToast } from "@chakra-ui/react";
import { Link as RouterLink, useParams } from "react-router-dom";

const DeduplicationSummary = ({ dedupSchema, isAdmin }) => {
  const { id, personID } = useParams();
  const toast = useToast();

  if (dedupSchema?.VALUE == null) return null;

  const handleClick = (e) => {
    if (!isAdmin) {
      e.preventDefault();
      toast({
        title: "Access Denied",
        description: "Only admins can view this deduplication case.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
  };

  return (
    <Box>
      <Text>
        {dedupSchema.VALUE >= 1 ? (
          // Redirect case
          <Link
            as={RouterLink}
            to={`/admin/caseDedup/${id}/${personID}`}
            onClick={handleClick}
          >
            <Text color="red">Pending</Text>
          </Link>
        ) : (
          // Done case
          <Box display="flex" gap={1} alignItems="center">
            <Text>Done</Text>
            <Link
              as={RouterLink}
              to={`/admin/caseDedup/${id}/${personID}`}
              onClick={handleClick}
            >
              <Text color="blue.500" fontSize="9px">
                (Manual Check)
              </Text>
            </Link>
          </Box>
        )}
      </Text>
    </Box>
  );
};

export default DeduplicationSummary;
